namespace TabAurous.OMS {
    export interface DesignForm {
        DesignId: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        DesignName: Serenity.StringEditor;
        Iteration: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ItemTypeId: Serenity.IntegerEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        AttributeId: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsConfigurable: Serenity.BooleanEditor;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        Purity: Serenity.DecimalEditor;
        Parts: Serenity.IntegerEditor;
        MappingId: Serenity.LookupEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        Image2: Serenity.ImageUploadEditor;
        Image3: Serenity.ImageUploadEditor;
        BOMDetails: DesignBOMEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: Serenity.DecimalEditor;
        Remarks: Serenity.StringEditor;
        Image4: Serenity.ImageUploadEditor;
        Image5: Serenity.ImageUploadEditor;
        Image6: Serenity.ImageUploadEditor;
        Image7: Serenity.ImageUploadEditor;
        Image8: Serenity.ImageUploadEditor;
        Video1: Serenity.ImageUploadEditor;
        Video2: Serenity.ImageUploadEditor;
    }

    export class DesignForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Design';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DesignForm.init)  {
                DesignForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = s.BooleanEditor;
                var w6 = CommonProductSizeLookup;
                var w7 = s.DecimalEditor;
                var w8 = s.ImageUploadEditor;
                var w9 = DesignBOMEditor;

                Q.initFormType(DesignForm, [
                    'DesignId', w0,
                    'DesignCode', w0,
                    'DesignName', w0,
                    'Iteration', w0,
                    'ProductTypeId', w1,
                    'ItemTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w1,
                    'CollectionId', w1,
                    'SuperTypeId', w1,
                    'AttributeId', w0,
                    'IsDisabled', w5,
                    'IsConfigurable', w5,
                    'HasBom', w5,
                    'MetalId', w1,
                    'KaratId', w1,
                    'MetalColorId', w1,
                    'ProductSizeId', w6,
                    'Purity', w7,
                    'Parts', w2,
                    'MappingId', w1,
                    'ImageName', w8,
                    'Image1', w8,
                    'Image2', w8,
                    'Image3', w8,
                    'BOMDetails', w9,
                    'Pieces', w2,
                    'Weight', w7,
                    'NetWeight', w7,
                    'DiamondPieces', w2,
                    'DiamondWeight', w7,
                    'StonePieces', w2,
                    'StoneWeight', w7,
                    'OtherPieces', w2,
                    'OtherWeight', w7,
                    'Remarks', w0,
                    'Image4', w8,
                    'Image5', w8,
                    'Image6', w8,
                    'Image7', w8,
                    'Image8', w8,
                    'Video1', w8,
                    'Video2', w8
                ]);
            }
        }
    }
}
